import { useNavigate, useParams } from "react-router";

import NotFoundPage from "@/app/NotFoundPage";
import { ErrorState } from "@/components/common/EmptyState";
import { Loader } from "@/components/common/Loader";
import { useProductStock } from "@/features/product-stocks/hooks/useProductStocks";
import ProductStockDetailPage from "@/features/product-stocks/ProductStockDetailPage";

export default function ProductStockDetailRoute() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { stock, isLoading, error, refresh } = useProductStock(id);

  if (!id) return <NotFoundPage />;
  if (isLoading) return <Loader />;
  if (error) return <ErrorState message={error} onRetry={() => refresh()} />;
  if (!stock) return <NotFoundPage />;

  return <ProductStockDetailPage stock={stock} onBack={() => navigate(-1)} onRefresh={() => refresh()} />;
}
